document.addEventListener('click',event=>{

  const tab=event.target.closest('[data-tab]');

  if(tab){const root=tab.closest('[data-tabs]');root.querySelectorAll('[role=tab]').forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1});root.querySelectorAll('[role=tabpanel]').forEach(p=>p.hidden=p.id!==tab.dataset.tab)}

  const videoButton=event.target.closest('[data-video-toggle]');

  if(videoButton){const video=videoButton.parentElement.querySelector('video');if(video.paused){video.play().then(()=>videoButton.textContent=videoButton.dataset.pause).catch(()=>{})}else{video.pause();videoButton.textContent=videoButton.dataset.play}}

  if(!event.target.closest('.live-nav-group'))document.querySelectorAll('.live-nav-group[open]').forEach(d=>d.open=false);

});

document.addEventListener('keydown',event=>{

  if(event.key==='Escape'){document.querySelectorAll('.live-nav-group[open]').forEach(d=>d.open=false);const menu=document.querySelector('.studio-menu-toggle');if(menu){menu.setAttribute('aria-expanded','false');document.getElementById(menu.getAttribute('aria-controls'))?.classList.remove('is-open')}}

  if(event.target.matches('[role=tab]')&&['ArrowLeft','ArrowRight','Home','End'].includes(event.key)){event.preventDefault();const tabs=[...event.target.closest('[role=tablist]').querySelectorAll('[role=tab]')];let index=tabs.indexOf(event.target);index=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;tabs[index].click();tabs[index].focus()}

});

document.addEventListener('change',event=>{if(event.target.matches('[data-localization]'))event.target.form.requestSubmit()});

document.addEventListener('DOMContentLoaded',()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)document.querySelectorAll('.live-hero video,.live-video-frame video').forEach(v=>{v.pause();const button=v.parentElement.querySelector('[data-video-toggle]');if(button)button.textContent=button.dataset.play})});



const cartDrawer=document.querySelector('[data-cart-drawer]');

const cartRoot=()=>window.Shopify?.routes?.root||'/';

const cartEndpoint=name=>name==='js'?`${cartRoot()}cart.js`:`${cartRoot()}cart/${name}`;

const escapeHtml=value=>String(value??'').replace(/[&<>"']/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));

const cartUploadUrl=value=>{try{const url=new URL(String(value),location.origin);return url.protocol==='https:'&&url.pathname.includes('/uploads/')&&(url.hostname==='cdn.shopify.com'||url.hostname===location.hostname||url.hostname.endsWith('.myshopify.com'))?url.href:null}catch{return null}};

const cartPropertyValue=value=>{const url=cartUploadUrl(value);return url?`<a href="${escapeHtml(url)}" target="_blank" rel="noopener">${escapeHtml(cartDrawer?.dataset.labelViewFile||'View image')}</a>`:escapeHtml(value)};

const formatMoney=cents=>{const currency=cartDrawer?.dataset.currency||'USD';try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency}).format((Number(cents)||0)/100)}catch{return `$${((Number(cents)||0)/100).toFixed(2)}`}};

const cartToggle=expanded=>document.querySelectorAll('[data-cart-toggle]').forEach(button=>button.setAttribute('aria-expanded',String(expanded)));

let cartBusy = false;
let cartRevision = 0;
let cartRead = 0;
const submittingForms = new WeakSet();
const setCartBusy = busy => {
  cartBusy = busy;
  if (!cartDrawer) return;
  cartDrawer.querySelector('.cart-drawer-panel')?.setAttribute('aria-busy', String(busy));
  cartDrawer.querySelectorAll('[data-cart-change], [data-cart-remove]').forEach(button => button.disabled = busy);
  const checkout = cartDrawer.querySelector('[data-cart-drawer-checkout]');
  if (busy) { checkout?.setAttribute('aria-disabled', 'true'); checkout?.setAttribute('tabindex', '-1'); }
  else { checkout?.removeAttribute('aria-disabled'); checkout?.removeAttribute('tabindex'); }
};
const cartStatus = (message, error = false) => {
  const status = cartDrawer?.querySelector('[data-cart-drawer-status]');
  if (status) { status.textContent = message || ''; status.hidden = !message; status.classList.remove('visually-hidden'); }
  const fallback = cartDrawer?.querySelector('[data-cart-recovery]');
  if (fallback) fallback.hidden = !error;
};
const cartResponseError = async (response, fallback) => {
  const result = await response.json().catch(() => ({}));
  return typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : fallback;
};
const productAddError = (form, message) => {
  let error = form.querySelector('[data-product-add-error]');
  if (!error) { error = document.createElement('p'); error.dataset.productAddError = ''; error.className = 'product-add-error'; error.setAttribute('role', 'alert'); form.querySelector('.studio-add-row')?.insertAdjacentElement('afterend', error); }
  error.textContent = message || ''; error.hidden = !message;
};

const renderCart=cart=>{if(!cartDrawer)return;const items=cartDrawer.querySelector('[data-cart-drawer-items]');const empty=cartDrawer.querySelector('[data-cart-drawer-empty]');const footer=cartDrawer.querySelector('[data-cart-drawer-footer]');const subtotal=cartDrawer.querySelector('[data-cart-drawer-subtotal]');const decrease=cartDrawer.dataset.labelDecrease||'Decrease quantity';const increase=cartDrawer.dataset.labelIncrease||'Increase quantity';const removeLabel=cartDrawer.dataset.labelRemove||'Remove';items.innerHTML=cart.items.map(item=>{const properties=Object.entries(item.properties||{}).filter(([key,value])=>value&&!key.startsWith('_')).map(([key,value])=>`<li>${escapeHtml(key)}: ${cartPropertyValue(value)}</li>`).join('');const title=item.product_title||item.title;return `<article class="cart-drawer-item"><a class="cart-drawer-item-media" href="${escapeHtml(item.url)}">${item.image?`<img src="${escapeHtml(item.image)}" alt="${escapeHtml(title)}" loading="lazy">`:''}</a><div class="cart-drawer-item-copy"><a class="cart-drawer-item-title" href="${escapeHtml(item.url)}">${escapeHtml(title)}</a>${item.variant_title&&item.variant_title!=='Default Title'?`<p>${escapeHtml(item.variant_title)}</p>`:''}${properties?`<ul>${properties}</ul>`:''}<div class="cart-drawer-item-meta"><div class="cart-drawer-quantity"><button type="button" data-cart-change="-1" data-cart-key="${escapeHtml(item.key)}" aria-label="${escapeHtml(decrease)}: ${escapeHtml(title)}">−</button><output>${item.quantity}</output><button type="button" data-cart-change="1" data-cart-key="${escapeHtml(item.key)}" aria-label="${escapeHtml(increase)}: ${escapeHtml(title)}">＋</button></div><strong>${formatMoney(item.final_line_price)}</strong></div><button class="cart-drawer-remove" type="button" data-cart-remove data-cart-key="${escapeHtml(item.key)}">${escapeHtml(removeLabel)}</button></div></article>`}).join('');const hasItems=cart.item_count>0;empty.hidden=hasItems;footer.hidden=!hasItems;if(subtotal)subtotal.textContent=formatMoney(cart.total_price);document.querySelectorAll('[data-cart-count]').forEach(node=>{node.textContent=cart.item_count});};

const refreshCart = async (keepStatus = false) => {
  if (!cartDrawer || cartBusy) return false;
  const revision = cartRevision, read = ++cartRead;
  try {
    const response = await fetch(cartEndpoint('js'), {headers: {Accept: 'application/json'}, cache: 'no-store'});
    if (!response.ok) throw new Error('Cart request failed');
    const cart = await response.json();
    if (cartBusy || revision !== cartRevision || read !== cartRead) return false;
    renderCart(cart);
    if (!keepStatus) cartStatus('');
    return true;
  } catch {
    if (revision === cartRevision && read === cartRead) cartStatus(cartDrawer.dataset.messageLoadError, true);
    return false;
  }
};
const openCart = async () => {
  if (!cartDrawer) return;
  cartDrawer.classList.add('is-open'); cartDrawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('cart-drawer-open'); cartToggle(true);
  cartDrawer.querySelector('.cart-drawer-panel')?.focus({preventScroll: true});
  await refreshCart();
};
const closeCart = () => {
  if (!cartDrawer) return;
  cartDrawer.classList.remove('is-open'); cartDrawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('cart-drawer-open'); cartToggle(false);
};
const changeCart = async (key, quantity) => {
  if (!key || cartBusy) return;
  const revision = ++cartRevision; setCartBusy(true); cartStatus(cartDrawer.dataset.messageUpdating);
  let failure = '';
  try {
    const response = await fetch(cartEndpoint('change.js'), {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({id: key, quantity: Math.max(0, quantity)})});
    if (!response.ok) throw new Error(await cartResponseError(response, cartDrawer.dataset.messageUpdateError));
    renderCart(await response.json()); cartStatus('');
  } catch (error) { failure = error.message === 'Failed to fetch' ? cartDrawer.dataset.messageUpdateError : error.message || cartDrawer.dataset.messageUpdateError; }
  finally { setCartBusy(false); }
  if (failure) { await refreshCart(true); if (revision === cartRevision) cartStatus(failure, true); }
};

document.addEventListener('click', event => {
  if (event.target.closest('[data-cart-drawer-checkout]') && cartBusy) { event.preventDefault(); return; }
  const toggle = event.target.closest('[data-cart-toggle]');
  if (toggle) { if (!cartDrawer) return; event.preventDefault(); cartDrawer.classList.contains('is-open') ? closeCart() : openCart(); return; }
  if (event.target.closest('[data-cart-drawer-close]')) { closeCart(); return; }
  const remove = event.target.closest('[data-cart-remove]');
  if (remove) { changeCart(remove.dataset.cartKey, 0); return; }
  const change = event.target.closest('[data-cart-change]');
  if (change) { const quantity = Number(change.closest('.cart-drawer-quantity')?.querySelector('output')?.textContent || 1) + Number(change.dataset.cartChange); changeCart(change.dataset.cartKey, quantity); }
});

document.addEventListener('keydown',event=>{if(event.key==='Escape'&&cartDrawer?.classList.contains('is-open'))closeCart()});

document.addEventListener('submit', async event => {
  const form = event.target.closest('[data-product-form]');
  if (!form || !cartDrawer || event.defaultPrevented) return;
  event.preventDefault();
  const submit = event.submitter || form.querySelector('[data-product-submit]');
  if (!submit || submit.disabled || submittingForms.has(form) || !form.reportValidity()) return;
  if (cartBusy) { productAddError(form, cartDrawer.dataset.messageUpdating); return; }
  const data = new FormData(form), label = submit.querySelector('[data-submit-label]');
  submittingForms.add(form); submit.disabled = true; productAddError(form, '');
  ++cartRevision; setCartBusy(true);
  if (label) label.textContent = submit.dataset.addingLabel;
  let rejected = false, ownsCart = true;
  try {
    const action = new URL(form.action, location.origin);
    const response = await fetch(`${action.pathname.replace(/\/$/, '')}.js`, {method: 'POST', headers: {Accept: 'application/json'}, body: data});
    if (!response.ok) { rejected = true; throw new Error(await cartResponseError(response, cartDrawer.dataset.messageAddError)); }
    setCartBusy(false); ownsCart = false;
    await openCart();
  } catch (error) {
    const message = rejected ? error.message : cartDrawer.dataset.messageAddUncertain || cartDrawer.dataset.messageAddError;
    productAddError(form, message);
  } finally {
    if (ownsCart) setCartBusy(false);
    submittingForms.delete(form);
    const available = form.querySelector('[data-product-variant]')?.selectedOptions[0]?.dataset.available !== 'false';
    submit.disabled = !available;
    if (label) label.textContent = available ? submit.dataset.availableLabel : submit.dataset.unavailableLabel;
  }
});

(() => {

  let observer;

  const visible = new Set();

  const observeActions = () => {

    observer?.disconnect();

    visible.clear();

    document.body.classList.remove('mobile-action-visible');

    if (!matchMedia('(max-width:749px)').matches) return;

    const viewport = window.visualViewport?.height || innerHeight;

    observer = new IntersectionObserver(entries => {

      entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));

      document.body.classList.toggle('mobile-action-visible', visible.size > 0);

    }, { rootMargin: `${-Math.max(0, viewport - 120)}px 0px 0px 0px` });

    document.querySelectorAll('.studio-add-row, .studio-cart-summary, .studio-signup > div').forEach(element => observer.observe(element));

  };

  observeActions();

  window.addEventListener('resize', observeActions);

  window.visualViewport?.addEventListener('resize', observeActions);

  document.addEventListener('shopify:section:load', observeActions);

})();



document.addEventListener('echoes:cart-refresh',event=>{if(event.detail?.open)openCart();else refreshCart()});

